module.exports = __webpack_public_path__ + "img/shipo-popup-icon-close.315b4c8e.svg";